import * as IntellectualService from '../../service/IntellectualService'
import * as types from '../mutation-types'

const state = {
	isShowSpeakerHome: false,
}
const getters = {
	isShowSpeakerHome: state => state.isShowSpeakerHome,
}
const mutations = {
	[types.IS_SHOW_SPEAKER_HOME](state, data) {
		state.isShowSpeakerHome = data
	}
}
const actions = {
	getSpeakerHome({ commit }, data) {
		return IntellectualService.getSpeakerHome(data).then(
			(res) => {
				commit(types.IS_SHOW_SPEAKER_HOME, res.data);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.IS_SHOW_SPEAKER_HOME, false);
				return Promise.reject(rea);
			}
		);
	},
	getCourseSearchList({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.getCourseSearchList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	getTagList({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.getTagList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	getSearchTagCourseList({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.getSearchTagCourseList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	getCourseDetail({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.getCourseDetail(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	collectAdd({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.collectAdd(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	cancelCollectAdd({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.cancelCollectAdd(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	coursePlayUrl({ commit, state }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.coursePlayUrl(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	saveViewTime({ commit }, data) {
		return IntellectualService.saveViewTime(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	searchDoctorCourse({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.searchDoctorCourse(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	focusSpeaker({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.focusSpeaker(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	focusSpeakerList({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.focusSpeakerList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	collectSearchList({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.collectSearchList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	collectMeeting({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.collectMeeting(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	collectQuestionnaire({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.collectQuestionnaire(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	collectLiveWeb({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.collectLiveWeb(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	specialSpeakerInfo({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.specialSpeakerInfo(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	accountAll({ commit }, data) {
		return IntellectualService.accountAll(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	beanAccount({ commit }, data) {
		return IntellectualService.beanAccount(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	beanDetailList({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.beanDetailList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	speakerAccount({ commit }, data) {
		return IntellectualService.speakerAccount(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	speakerDetailList({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.speakerDetailList(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	canWithdrawAmount({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.canWithdrawAmount(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	applyWithdraw({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.applyWithdraw(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	// 支付流程
	queryCourseFee({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.queryCourseFee(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	submitOrder({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.submitOrder(data).then(
			(res) => {
				console.log(res, "000000000000000000000000000000000");
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	queryOrderBill({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.queryOrderBill(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	knowledgeOrderPay({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.knowledgeOrderPay(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	wechatPayResult({ commit }, data) {
		commit(types.REQUEST_DOING);
		return IntellectualService.wechatPayResult(data).then(
			(res) => {
				commit(types.REQUEST_CLOSE);
				return Promise.resolve(res.data);
			},
			(rea) => {
				commit(types.REQUEST_CLOSE);
				return Promise.reject(rea);
			}
		);
	},
	getFunBeanList({ commit }, data) {
		return IntellectualService.getFunBeanList(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getRecommendedList({ commit }, data) {
		return IntellectualService.getRecommendedList(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getShareQrCode({ commit }, data) {
		return IntellectualService.getShareQrCode(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getInviteQrCode({ commit }, data) {
		return IntellectualService.getInviteQrCode(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	shareCourse({ commit }, data) {
		return IntellectualService.shareCourse(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	shareSpeaker({ commit }, data) {
		return IntellectualService.shareSpeaker(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getTaskFunBean({ commit }, data) {
		return IntellectualService.getTaskFunBean(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getFunBeanRuleList({ commit }, data) {
		return IntellectualService.getFunBeanRuleList(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getShareHandle({ commit }, data) {
		return IntellectualService.getShareHandle(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getSearchCourseList({ commit }, data) {
		return IntellectualService.getSearchCourseList(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getCollectStatus({ commit }, data) {
		return IntellectualService.getCollectStatus(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getRmbAccontInfo({ commit }, data) {
		return IntellectualService.getRmbAccontInfo(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getLiveSpeakerAmount({ commit }, data) {
		return IntellectualService.getLiveSpeakerAmount(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getLimitStatus({ commit }, data) {
		return IntellectualService.getLimitStatus(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	getPurchasedRecommendedList({ commit }, data) {
		return IntellectualService.getPurchasedRecommendedList(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
	withdrawingAmount({ commit }, data) {
		return IntellectualService.withdrawingAmount(data).then(
			(res) => {
				return Promise.resolve(res.data);
			},
			(rea) => {
				return Promise.reject(rea);
			}
		);
	},
};
export default {
	state,
	getters,
	actions,
	mutations
}
